import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page7 = () => {
  return (
    <PageTypeA title={pagesDataA[3].title} subtitle={pagesDataA[3].subtitle} image={pagesDataA[3].image}/>
  );
};

export default Page7;
